module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_baby_ac75b4c416d54c5c2c7af3536d10de30.png";